import type { TaskButtonProps } from "@sb1/ffe-buttons-react";
import { TaskButton as FellesTaskButton } from "@sb1f/buttons";
import { getCustomData } from "~/utils/tracking/utils";

type Props = TaskButtonProps & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const TaskButton = ({ track = true, trackingData, ...props }: Props) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesTaskButton customData={customData} {...props} />;
};

export default TaskButton;
